const EVENT_IMAGE_BY_SPORT_KEY: Readonly<Record<string, string>> = {
  basketball: '/static/images/events/og/basketball.png',
  cycling: '/static/images/events/og/cycling.png',
  football: '/static/images/events/og/football.png',
  running: '/static/images/events/og/running.png',
  tennis: '/static/images/events/og/tennis.png',
  volleyball: '/static/images/events/og/volleyball.png',
  yoga: '/static/images/events/og/yoga.png',
};

export const DEFAULT_EVENT_IMAGE = '/static/images/events/og/default.png';
export const EVENT_SOCIAL_IMAGE_VERSION = '20260721';

export function getEventSportImage(sportKey?: string | null) {
  if (!sportKey) {
    return DEFAULT_EVENT_IMAGE;
  }

  const eventImage = EVENT_IMAGE_BY_SPORT_KEY[sportKey];

  return typeof eventImage === 'string' ? eventImage : DEFAULT_EVENT_IMAGE;
}

export function getEventSocialImage(sportKey?: string | null) {
  return `${getEventSportImage(sportKey)}?v=${EVENT_SOCIAL_IMAGE_VERSION}`;
}
